// extracted by mini-css-extract-plugin
export default {"progressBar":"Loader_progressBar__M25fk","bar":"Loader_bar__Lv8eI","progress":"Loader_progress__-aRt7","loader":"Loader_loader__2+bIE"};